import { useLanguage } from "@tlc/ls2pac/components/Language";
import { useLocalHoldingsBranch } from "../../../resource/LocalHoldingsBranch";
import React, { useMemo } from "react";
import { useItemAvailability } from "../../../resource/ItemAvailability";
import { Box, Skeleton, Typography } from "@mui/material";
import { useBranchLimits } from "@tlc/ls2pac/components/BranchLimits";
import { ResourceView } from "@tlc/ls2pac/dto/ResourceView";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";

export const LSResultItemShelfLocation = ({
  resource,
  isReserves,
}: {
  resource: ResourceView | ResourceDWR;
  isReserves?: boolean;
}) => {
  const { translate } = useLanguage();
  const { selectedBranches } = useBranchLimits();
  const { branchIdentifier: localHoldingsBranch } = useLocalHoldingsBranch();
  //   sync
  const shelfLocationBranch = useMemo(() => {
    if ((selectedBranches ?? []).length === 1)
      return selectedBranches[0].identifier;
    if (localHoldingsBranch) return localHoldingsBranch;
    return null;
  }, [localHoldingsBranch, selectedBranches]);
  //   sync
  const localHoldings = useMemo(() => {
    if (!shelfLocationBranch) {
      return null;
    }

    return (resource.holdingsInformations || [])
      .filter((hi) => hi.branchIdentifier === shelfLocationBranch)
      .filter((hi) => !isReserves || hi.reserved);
  }, [resource, shelfLocationBranch, isReserves]);
  //   async
  const { itemAvailability, ready } = useItemAvailability(
    localHoldings,
    resource
  );
  //   async
  const shelfLocation = useMemo(() => {
    if (!ready || (localHoldings ?? []).length === 0) {
      return null;
    }
    // available > non-circulating > first local holding
    const holdingForOnShelf =
      localHoldings.find(
        (lh) => (itemAvailability.get(lh.barcode) || {}).available
      ) ||
      localHoldings.find(
        (lh) => (itemAvailability.get(lh.barcode) || {}).nonCirculating
      ) ||
      localHoldings[0];
    const { collectionName, shelfLocation } = holdingForOnShelf;
    return [collectionName?.trim(), shelfLocation?.trim()]
      .filter((token) => token?.length > 0)
      .join(" - ");
  }, [ready, itemAvailability, localHoldings]);
  //   ContentDM, RSS, or Downloadable
  if (resource.rtype !== 1 || resource.downloadable) {
    console.warn("Incorrect use of ShelfLocation");
    return null;
  }
  //   No branch for shelfLocation
  //   No holdings at that branch
  if ((localHoldings ?? []).length === 0 || !shelfLocationBranch) {
    return null;
  }
  return (
    <Box>
      <Typography sx={{ lineHeight: "1" }} variant="overline">
        {translate("findOnShelf")}
      </Typography>
      {ready && !!shelfLocation ? (
        <Typography sx={{ padding: 0 }}>{shelfLocation}</Typography>
      ) : (
        <Skeleton variant="text" width={"100%"} height={24} />
      )}
    </Box>
  );
};
